<template>
    <div class="flex gap-3 mb-3">
        <HorsePreviewDate :label="$t('message.horsePreview.dates.birth')" :value="selectedHorse.dateOfBirth">
            <template #additionalInformation>{{ birthPlaceText }}</template>
        </HorsePreviewDate>
        <HorsePreviewDate v-if="selectedHorse.dateOfImport" :label="$t('message.horsePreview.dates.import')" :value="selectedHorse.dateOfImport">
            <template #additionalInformation>{{ importPlaceText }}</template>
        </HorsePreviewDate>
        <HorsePreviewDate v-if="selectedHorse.dateOfControl" :label="$t('message.horsePreview.dates.control')" :value="selectedHorse.dateOfControl">
            <template #additionalInformation>{{ controlledBy }}</template>
        </HorsePreviewDate>
        <HorsePreviewDate v-if="selectedHorse.dateOfExport" :label="$t('message.horsePreview.dates.export')" :value="selectedHorse.dateOfExport">
            <template #additionalInformation>{{ exportedTo }}</template>
        </HorsePreviewDate>
        <HorsePreviewDate v-if="selectedHorse.dateOfDeath" :label="$t('message.horsePreview.dates.death')" :value="selectedHorse.dateOfDeath">
        </HorsePreviewDate>
    </div>
</template>

<script>
import HorsePreviewDate from "@/views/horse/horseList/components/HorsePreviewDate.vue";

export default {
    name: "HorsePreviewDates",
    components: {
        HorsePreviewDate,
    },

    props: {
        selectedHorse: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            countryPrepositions: {
                "USA": this.$t("message.horsePreview.dates.theUSA"),
                "United States": this.$t("message.horsePreview.dates.theUnitedStates"),
                "UK": this.$t("message.horsePreview.dates.theUK"),
                "Netherlands": this.$t("message.horsePreview.dates.theNetherlands"),
                "Philippines": this.$t("message.horsePreview.dates.thePhilippines"),
            }
        };
    },

    computed: {
        birthPlaceText() {
            if (!this.selectedHorse || !this.selectedHorse.birthCountry) return "";
            const country = this.selectedHorse.birthCountry;
            return this.$t("message.horsePreview.dates.in") + " " + (this.countryPrepositions[country] || country);
        },
        importPlaceText() {
            if (!this.selectedHorse || !this.selectedHorse.importCountry) return "";
            const country = this.selectedHorse.importCountry;
            return this.$t("message.horsePreview.dates.from") + " " + (this.countryPrepositions[country] || country);
        },
        controlledBy() {
            if (!this.selectedHorse || !this.selectedHorse.controllerFullname) return "";
            return this.$t("message.horsePreview.dates.by") + " " + this.selectedHorse.controllerFullname;
        },
        exportedTo() {
            if (!this.selectedHorse || !this.selectedHorse.exportCountry) return "";
            return this.$t("message.horsePreview.dates.to") + " " + this.selectedHorse.exportCountry;
        },
    },
};
</script>
